import AccessGroupList from "./AccessGroupList";

export default AccessGroupList;